import { render, staticRenderFns } from "./DeclarationItem.vue?vue&type=template&id=20356dee&scoped=true&"
import script from "./DeclarationItem.vue?vue&type=script&lang=js&"
export * from "./DeclarationItem.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationItem.vue?vue&type=style&index=0&id=20356dee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20356dee",
  null
  
)

export default component.exports